;(function ($) {

    const BREAKPOINT = mat_theme.main_menu_breakpoint;
    const BUTTON_SELECTOR = '.generic-sidebar .widget_nav_menu .widgettitle';
    const MENU_SELECTOR = '.widget_nav_menu';

    let menu_state_mobile_is_active = false;

    const addSetup_mobile = () => {
        if (menu_state_mobile_is_active) return;
        menu_state_mobile_is_active = true;

        $(BUTTON_SELECTOR).attr('tabindex', 0);
        $(BUTTON_SELECTOR).attr('role', "button");
        $(MENU_SELECTOR).attr('aria-expanded', false);
        // $(MENU_SELECTOR).attr('disabled', true);

        $(BUTTON_SELECTOR).on('click', function (ev) {
            ev.preventDefault();
            toggleMenu($(this));
        });

        $(BUTTON_SELECTOR).on('keypress', function (ev) {
            if (ev.which == 13) toggleMenu($(this));
        });

    };

    const toggleMenu = ($menuButton) => {
        $menuButton.closest(MENU_SELECTOR).toggleClass('open');
        if ($menuButton.closest(MENU_SELECTOR).hasClass('open')) {
            $(MENU_SELECTOR).attr('aria-expanded', true);
            // $(MENU_SELECTOR).attr('disabled', false);
        } else {
            $(MENU_SELECTOR).attr('aria-expanded', false);
            // $(MENU_SELECTOR).attr('disabled', true);
        }
    };

    const clearSetup_mobile = () => {
        if (!menu_state_mobile_is_active) return;
        menu_state_mobile_is_active = false;

        $(BUTTON_SELECTOR).off();
        $(BUTTON_SELECTOR).removeAttr('tabindex');
        $(BUTTON_SELECTOR).removeAttr('role');
        $(MENU_SELECTOR).removeAttr('aria-expanded');
        // $(MENU_SELECTOR).removeAttr('disabled');
    };

    const window_resize_action = () => {
        if (window.innerWidth >= BREAKPOINT) {
            clearSetup_mobile();
            // addSetup_desktop();
        } else {
            // clearSetup_desktop();
            addSetup_mobile();
        }
    };

    window_resize_action();
    window.addEventListener("resize", window_resize_action);
})(jQuery);
